import { ForecastSeriesCompletedWithoutMeasure } from '@api-response-types/forecast-series.response';
import { getFilenameTimestamp } from './filename-timestamp';

function calculateInitialForecastIndexMonth(
  forecastSeries: ForecastSeriesCompletedWithoutMeasure,
): { monthOfInitialForecastIndex: number; yearOfInitialForecastIndex: number } {
  const idx = forecastSeries.initialForecastIndex;
  const unixTime = forecastSeries.originalDates[idx][0];
  const unixTimeDate = new Date(unixTime);

  return {
    monthOfInitialForecastIndex: unixTimeDate.getMonth() + 1,
    yearOfInitialForecastIndex: unixTimeDate.getFullYear(),
  };
}

export function getPeriodsSapFormatFilename(
  monthOfInitialForecastIndex?: number,
  yearOfInitialForecastIndex?: number,
  forecastSeries?: ForecastSeriesCompletedWithoutMeasure,
  options?: { withTimestamp?: boolean },
): string {
  if (
    !monthOfInitialForecastIndex &&
    !yearOfInitialForecastIndex &&
    !forecastSeries
  ) {
    throw new Error(
      'Either monthOfInitialForecastIndex or forecastSeries must be provided',
    );
  }
  if (
    (!monthOfInitialForecastIndex || !yearOfInitialForecastIndex) &&
    forecastSeries
  ) {
    const result = calculateInitialForecastIndexMonth(forecastSeries);
    monthOfInitialForecastIndex = result.monthOfInitialForecastIndex + 1;
    yearOfInitialForecastIndex = result.yearOfInitialForecastIndex;
  }
  if (!monthOfInitialForecastIndex || !yearOfInitialForecastIndex) {
    throw new Error(
      'monthOfInitialForecastIndex or yearOfInitialForecastIndex undefined',
    );
  }

  const october = new Date(new Date().getFullYear(), 10, 1); // 10 because october is Period1 and not Period0
  const months = (monthOfInitialForecastIndex - october.getMonth() + 12) % 12;
  // months should always have two digits
  const period = months < 10 ? `0${months}` : months;
  // fiscal year starts in october, so if the month of the initial forecast date is in or after october we need to add 1 to the current year
  const fiscalYear =
    monthOfInitialForecastIndex >= 11 // 11 because monthOfInitialForecastIndex is +1 because months start with 0
      ? yearOfInitialForecastIndex + 1
      : yearOfInitialForecastIndex;

  const base = `Ab_Periode${period}_${fiscalYear}`;
  return options?.withTimestamp ? `${base}_${getFilenameTimestamp()}` : base;
}
